module.exports = __webpack_public_path__ + "img/2_06.d8841201.jpg";